import { Text } from "@chakra-ui/layout";
import React from "react";
import "../../App.css";
import HeroSection from "../HeroSection";
import ImageGrid from "../ImageGrid";
import Sidebar from "../Sidebar";
import { useAuth } from "../contexts/AuthContext";

function Home() {
  //const { currentUser } = useAuth();

  return (
    <>
      <div className="dashboard">
        <ImageGrid />
        <Sidebar />
      </div>
    </>
  );
}

export default Home;
